import { render } from "./CloneSubMenu.vue?vue&type=template&id=3bc2db71"
import script from "./CloneSubMenu.vue?vue&type=script&lang=js"
export * from "./CloneSubMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__